// HomeBanner.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ Import Autoplay
import "swiper/css";
import "swiper/css/pagination";

const HomeBanner = () => {
  return (
    <div className="swiper mySwiper swiper-initialized swiper-horizontal swiper-backface-hidden">
      <Swiper
        modules={[Pagination, Autoplay]} // ✅ Include Autoplay
        pagination={{ clickable: true }}
        spaceBetween={10}
        slidesPerView={1}
        autoplay={{                 // ✅ Configure autoplay
          delay: 4500,
          disableOnInteraction: false,
        }}
      >
        
        {/* Slide 2 */}
        <SwiperSlide>
          <div className="content-txt slide-1">
            <h2 className="heading">Sell Anytime, Anywhere 100% Digitally</h2>
            <p className="text">
              Unlock your Superpower now. Top partners in the industry are powered by
              BajajCapital Insurance Broking Limited
            </p>
            <div className="icon-box d-flex">
              <div className="icon-text d-flex">
                <img src="/assets/images/icons/icon-policy.svg" alt="icon" />
                <div className="icon-data">
                  <p>45 Lacs+</p>
                  <p>Policies Sold</p>
                </div>
              </div>
              <div className="icon-text d-flex">
                <img src="/assets/images/icons/icon-map.svg" alt="icon" />
                <div className="icon-data">
                  <p>40+</p>
                  <p>Insurers</p>
                </div>
              </div>
              <div className="icon-text d-flex">
                <img src="/assets/images/icons/icon-partnership.svg" alt="icon" />
                <div className="icon-data">
                  <p>40,000+</p>
                  <p>Partners</p>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <div className="content-txt slide-3">
            <h2 className="heading">1 Year of Transforming Insurance industry Digitally</h2>
            <p className="text">
              Now it’s easier than ever to quote, sell, and manage insurance policies online
            </p>
            <p className="sub-text">Experience The Future of Insurance with:</p>
            <ul className="checklist">
              <li>BH Series Motor Insurance</li>
              <li>Quote Shortlisting</li>
              <li>Real-time Policy copy</li>
            </ul>
            <img
              src="/assets/images/carousel/slider2_creative.png"
              className="img-fluid creative"
              alt="creative"
            />
          </div>
        </SwiperSlide>

        {/* Slide 4 */}
        <SwiperSlide>
          <div className="content-txt slide-4">
            <h2 className="heading">Build a Rewarding Career with BajajCapital Insurance</h2>
            <p className="text">
              Let us invest in your growth and development, so you succeed with us - Become an
              agent today
            </p>
            <a
              href="https://pos.bajajcapitalinsurance.com/sign_up"
              target="_blank"
              rel="noopener noreferrer"
              className="btn today"
            >
              Earn with Us
            </a>
            <img
              src="/assets/images/carousel/slider2_creative.png"
              className="img-fluid creative"
              alt="creative"
            />
          </div>
        </SwiperSlide>
        
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="content-txt slide-2">
            <h2 className="heading">
              Introducing Renewals for Health &amp; Motor Insurance
            </h2>
            <p className="text">
              Now get your clients' policies renewed in an instant
            </p>
            <img
              src="/assets/images/carousel/slider2_creative.png"
              className="img-fluid creative"
              alt="creative"
            />
          </div>
        </SwiperSlide>
        
      </Swiper>
    </div>
  );
};

export default HomeBanner;
